import React from "react";
import MaterialTable, { MaterialTableProps } from "@material-table/core";


export const EditableTable : React.FC<MaterialTableProps<any>> =
(props: MaterialTableProps<any>) => <MaterialTable
  {...props}
  style={{ padding: "1.5em", ...props.style }}
/>;
